import { PermissionAction } from '@entities/client/permission';

import type { NavItem } from '../model';

// Drops nav items the user has no permission for. An item with a `resource` is
// hidden when the required action (defaults to `Read`, since navigation is usually
// about viewing) is not granted; a group (item with children) is hidden when all
// children are filtered out. App-agnostic: resource/action may come from either app's
// enum, so the `${Resource}:${Action}` key is built directly here.
export const filterNavigationItems = (
  items: NavItem[],
  permissions: string[],
): NavItem[] =>
  items.flatMap((item) => {
    if (
      item.resource &&
      !permissions.includes(`${item.resource}:${item.action ?? PermissionAction.Read}`)
    )
      return [];

    if (item.children) {
      const children = filterNavigationItems(item.children, permissions);
      return children.length === 0 ? [] : [{ ...item, children }];
    }

    return [item];
  });
